import Vue from 'vue'

Vue.directive('click-outside', {
    bind (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }

            console.warn(warn)
        }

        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = e => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
                binding.value(e)
            }
        }

        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
    },
    unbind (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
    }
})

Vue.directive('click-scroll-to-id', {
    bind (el, binding, vNode) {
        // Define Handler and cache it on the element
        const handler = e => {
            const argEl = document.getElementById(binding.arg)

            if (argEl !== null) {
                argEl.scrollIntoView(
                    {behavior: 'smooth'}
                )
            }
        }

        el.__vueClick__ = handler

        // add Event Listeners
        el.addEventListener('click', handler)
    },
    unbind: function (el, binding) {
        // Remove Event Listeners
        el.removeEventListener('click', el.__vueClick__)
        el.__vueClick__ = null
    }
})

Vue.directive('click-scroll-to-id', {
    bind (element, binding) {
        if (!binding.value) return

        element.oninput = e => {
            if (!e.isTrusted) return

            element.value = element.value.replace('+7', '')

            let x = element.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

            element.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
            element.value = element.value.replace(/^/, '+7 ')

            let event = document.createEvent('Event')

            event.initEvent('input', true, true)
            element.dispatchEvent(event)
        }
    }
})

Vue.directive('check-validation-this-form', {
    bind: function (el, binding, vNode) {
        const handler = (e) => {
            e.preventDefault()
            e.stopPropagation()
            const $thisForm = el.closest('form')
            const $vueEls = $thisForm.querySelectorAll('.vm-form-el')
            let hasErrors = false

            $vueEls.forEach(el => {
                el.__vue__.validate()
            })

            setTimeout(() => {
                const $vueElsErrors = $thisForm.querySelectorAll('.vm-form-el__error')

                $vueElsErrors.forEach(el => {
                    if (el.style.display !== 'none') {
                        hasErrors = true
                    }
                })

                if (!hasErrors) {
                    try {
                        const inputHiddenButton = document.createElement('input')
                        let val = el.getAttribute('value')

                        if (val === undefined) {
                            val = 'Y'
                        }

                        inputHiddenButton.setAttribute('type', 'hidden')
                        inputHiddenButton.setAttribute('value', val)
                        inputHiddenButton.setAttribute('name', el.getAttribute('name'))

                        $thisForm.appendChild(inputHiddenButton)
                    } catch (error) {
                        console.log(error)
                    }

                    $thisForm.submit()
                }
            }, 1000)
        }

        el.__vueCheckThisForm__ = handler

        // add Event Listeners
        el.addEventListener('click', handler)
    },
    unbind: function (el, binding) {
        // Remove Event Listeners
        el.removeEventListener('click', el.__vueCheckThisForm__)
        el.__vueCheckThisForm__ = null
    }
})
